export class ComprobanteEncabezado {
  id: string;
  tipoMovimiento: number;
  prefijo: number;
  numeroComprobante: number;
  codigoAeroplanta: string;
  fechaEmision: string;
  fechaVencimiento: Date;
  netoTotal: number;
  ivaTotal: number;
  total: number;
  razonSocialCliente: string;
  tipoMoneda: number;
  numerosAerovales: string;
  patentes: string;
  litros: number;

  //para la carga
  loadIcon: boolean;
}